import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from "../../utils/axiosInstance";
import "@fontsource/oswald";
import HeaderBlue from '../../components/HeaderBlue';
import FooterBlue from '../../components/FooterBlue';

const DriverLogin = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleLogin = async (e) => {
        e.preventDefault();

        try {
            const res = await api.post('/drivers/login', {
                email,
                password,
            });

            if (res.data.success || res.status === 200) {
                localStorage.setItem('driver', JSON.stringify(res.data.driver));
                navigate('/driver/dashboard');
            }
        } catch (error) {
            console.error('Login failed:', error);
            alert(error.response?.data?.message || 'Login failed');
        }
    };

    return (
        <div className="bg-gray-100 min-h-screen flex flex-col font-oswald">
            <HeaderBlue />
            {/* Hero Section */}
            <section className="w-full py-60 relative"
                style={{
                    backgroundImage: "url('./assets/LOGIN.webp')",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }}>
                <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-white/10 z-0"></div>
                <div className="md:px-40 relative z-10"></div>
            </section>

            {/* Login Form Section */}
            <div className="flex items-center justify-center p-4 -mt-40 relative z-10 mb-10">
                <div className="w-full max-w-md p-8 rounded-lg shadow-xl border border-gray-300 bg-white/85 backdrop-blur-md">
                    <div className="text-center mb-8">
                        <h1 className="text-3xl font-bold text-primary mb-2">DRIVER LOGIN</h1>
                        <p className="text-gray-600">Access your driver dashboard</p>
                    </div>

                    <form onSubmit={handleLogin} className="space-y-6">
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                                Email
                            </label>
                            <input
                                type="email"
                                id="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-secondary focus:border-transparent"
                                placeholder="Enter your email"
                            />
                        </div>

                        <div>
                            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                                Password
                            </label>
                            <input
                                type="password"
                                id="password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-secondary focus:border-transparent"
                                placeholder="Enter your password"
                            />
                        </div>

                        <div className="flex items-center justify-between">
                            <div className="flex items-center">
                                <input
                                    id="remember-me"
                                    name="remember-me"
                                    type="checkbox"
                                    className="h-4 w-4 text-secondary focus:ring-secondary border-gray-300 rounded"
                                />
                                <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-700">
                                    Remember me
                                </label>
                            </div>
                            <div className="text-sm">
                                <button
                                    type="button"
                                    onClick={() => navigate('/forget-password')}
                                    className="font-medium text-secondary hover:text-blue-600"
                                >
                                    Forgot password?
                                </button>
                            </div>

                        </div>

                        <div>
                            <button
                                type="submit"
                                className="w-full bg-secondary text-white font-bold py-2 px-4 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary transition"
                            >
                                LOG IN
                            </button>
                        </div>
                    </form>
                    <div className="flex items-center justify-center mt-2 mb-8">
                        <button
                            onClick={() => navigate('/driver-registration')}
                            className="text-sm text-secondary px-3 py-2 font-semibold hover:underline hover:text-black transition"
                        >
                            Not yet registered?{' '}
                            <span className="text-base font-bold">REGISTER NOW!</span>                        </button>
                    </div>
                    <div className="mt-6 text-center text-sm">
                        <p className="text-gray-600">
                            By logging into your account, you agree to our
                            <a href="/terms-of-use" className="text-secondary font-medium"> Terms of Use </a> and
                            <a href="/privacy-policy" className="text-secondary font-medium"> Privacy Policy</a>, and to the use of cookies as described therein.
                        </p>
                    </div>
                </div>
            </div>
            <FooterBlue />
        </div>
    );
};

export default DriverLogin;
